import InteractiveTable, {
  Column as TableColumn,
} from 'components/InteractiveTable';
import { TransactionOperation } from 'further-types/lp/transaction';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { CalendarDay, numberToCurrencyString } from 'further-ui/utils';

type Props = {
  reconcilableTransactions: Array<{
    id: string;
    transactionDate: CalendarDay;
    operationType: TransactionOperation;
    unreconciledAmountTcy: number;
    transactionCurrency: CurrencyCode;
  }>;
  onTransactionSelection: (selectedTransactionIds: Array<string>) => void;
  selectedTransactionIds: Array<string>;
};

const ReconcilableTransactions: React.FC<Props> = ({
  reconcilableTransactions,
  onTransactionSelection,
  selectedTransactionIds,
}) => {
  const columns: Array<TableColumn<(typeof reconcilableTransactions)[number]>> =
    [
      {
        field: 'transactionDate',
        headerName: 'Date',
        renderCell: ({ row }) => row.transactionDate.toReadable(),
        flex: 1,
      },
      {
        field: 'description',
        headerName: 'Description',
        flex: 1,
      },
      {
        field: 'debit',
        headerName: 'Debit',
        renderCell: ({ row }) =>
          numberToCurrencyString(
            row.operationType === TransactionOperation.Debit
              ? row.unreconciledAmountTcy
              : undefined,
            {
              fallback: '-',
              currency: row.transactionCurrency,
            },
          ),
        flex: 1,
      },
      {
        field: 'credit',
        headerName: 'Credit',
        renderCell: ({ row }) =>
          numberToCurrencyString(
            row.operationType === TransactionOperation.Credit
              ? row.unreconciledAmountTcy
              : undefined,
            {
              fallback: '-',
              currency: row.transactionCurrency,
            },
          ),
        flex: 1,
      },
    ];

  return (
    <InteractiveTable
      selectable
      onRowSelection={onTransactionSelection}
      selectedRows={selectedTransactionIds}
      id="manual-journal-reconcilable-transactions"
      // @ts-expect-error - We need to fix interactive table types
      columns={columns}
      rows={reconcilableTransactions}
      disableSorting
      disableTableConfiguration
      fullHeight
    />
  );
};

export default ReconcilableTransactions;
